/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.roles.controllers', [])

.controller('RolesController', ['$scope', function($scope) {

    $scope.roles = {

      model: "Your spankin new application.roles.default view!",

      init: function() {},

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.roles.init();

}]);